<template>
  <span
    class="owal panel header button"
    @click="handleClick(identifier)"
  >
    {{ this.title }}
  </span>
</template>

<script>
export default {
  name: 'OwalPanelHeaderButton',
  props: {
    title: {
      type: String,
      default: 'Button',
    },
    identifier: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick: function (identifier) {
      this.$emit('button-click', identifier)
    },
  },
}
</script>

<style scoped>
.owal.panel.header.button {
  width: fit-content;
  background-color: #c0ccda;
  color: #475669;
  border: 1px solid #475669;
  border-radius: 5px;
  font-size: 14px;
  font-family: 'Lato-Regular';
  padding: 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 9rem;
  cursor: pointer;
}

.owal.panel.header.button + .owal.panel.header.button {
  margin-left: 0.5rem;
}

.owal.panel.header.button:hover {
  color: #c0ccda;
  background-color: #475669;
}
</style>
